import { memo } from 'react';
import { useEditMode } from '../../focus/useIsEditMode';
import { EditableQuestion } from '../EditableQuestion';
import { AddOptionButton } from './AddOptionButton';
import { EditableMultipleItem } from './EditableMultipleItem';
import { SortableContainer } from './SortableContainer';
import { type useMultipleOptions } from './useMultipleOptions';
export const EditableMultiple = memo((props: Omit<ReturnType<typeof useMultipleOptions>, 'handleShuffle'>) => {
  const {
    options,
    handleRemove,
    handleMove,
    handleAdd
  } = props;
  const {
    isEditMode
  } = useEditMode();
  return <div className="flex flex-col gap-xs pb-xs" onClick={e => e.stopPropagation()}>
        <EditableQuestion />

        <div className="relative flex flex-col gap-xs">
          <SortableContainer items={options.map(o => o.key)} onDragEnd={handleMove}>
            {options.map((option, choiceIndex) => {
          return <EditableMultipleItem key={option.key} id={option.key} choiceIndex={choiceIndex} isEditMode={isEditMode} isLastOption={choiceIndex === options.length - 1} onRemove={options.length > 2 && isEditMode ? () => handleRemove(choiceIndex) : undefined} />;
        })}
          </SortableContainer>
        </div>
        {options.length < 5 && isEditMode && <div className="pt-xs">
            <AddOptionButton onClick={e => {
        e.stopPropagation();
        handleAdd();
      }} />
          </div>}
      </div>;
});